import logoImg from "../assets/images/logo/logo1.png";

// details
export const companyDetails = {
  logo: logoImg,
  phone: "+917077770975",
  email: "contactus@eskaliotech.com",
  location1:
    "Malviya Nagar, Eldeco centre, Block A, Shivalik Colony, Malviya Nagar, Delhi, DL 110017",
  location2:
    "Salarpuria Symbiosis, Ground floor Bannerghatta Road Arekere Village, Begur Hobli, Bengaluru, Karnataka 560076",
  twitter: "https://x.com/ESKALIOTECH",
  linkedin: "https://www.linkedin.com/company/eskaliotech/",
  instagram: "https://www.instagram.com/eskaliotech?igsh=aWZsdnA1YzZnOXBx",
  facebook: "https://www.facebook.com/share/19m3LDU3Me/",
};

export const landingPageNavLinks = [
  {
    id: 1,
    label: "Home",
    link: "banner",
  },
  {
    id: 2,
    label: "Services",
    link: "services",
  },
  {
    id: 3,
    label: "Portfolio",
    link: "portfolio",
  },
  {
    id: 4,
    label: "Reviews",
    link: "reviews",
  },
  {
    id: 5,
    label: "Contact",
    link: "contact",
  },
];

// website pages links
export const websitePagesLinks = [
  {
    id: 1,
    link: "/",
    label: "Home",
  },
  {
    id: 2,
    link: "/about-us",
    label: "About Us",
  },
  {
    id: 3,
    link: "/portfolio",
    label: "Portfolio",
  },
  {
    id: 4,
    link: "/services",
    label: "Services",
  },
  {
    id: 5,
    link: "/blogs",
    label: "Blogs",
  },
  {
    id: 6,
    link: "/contact",
    label: "Contact Us",
  },
];

// web development services
export const webDevelopmentServices = [
  {
    id: 1,
    title: "E-commerce Website",
    icon: require("../assets/images/icons/online-shopping.png"),
    description:
      "Empower your online business with custom e-commerce solutions. Our platforms enhance customer engagement, optimize operations, and drive significant revenue growth.",
  },
  {
    id: 2,
    title: "Social Media Websites",
    icon: require("../assets/images/icons/socialmedia.png"),
    description:
      "Get bespoke social media websites that captivate and engage your audience, fostering brand loyalty and driving sustainable growth.",
  },
  {
    id: 3,
    title: "Landing Pages",
    icon: require("../assets/images/icons/landing-page.png"),
    description:
      "Crafting high-converting landing pages designed to capture attention and drive immediate action. Tailored designs to amplify your brand’s message and boost conversions.",
  },
  {
    id: 4,
    title: "Custom Websites",
    icon: require("../assets/images/icons/software-development.png"),
    description:
      "Delivering custom-built websites tailored to your unique business needs. We blend creativity with functionality to create an exceptional online presence that enhances user experience.",
  },
];

// app development services
export const appDevelopmentServices = [
  {
    id: 1,
    title: "iOS App Development",
    icon: require("../assets/images/icons/ios-development.png"),
    description:
      "Our expert developers utilize Swift and Objective-C to create powerful, high-performance iOS apps. We focus on optimizing for speed, responsiveness, and overall performance.",
  },
  {
    id: 2,
    title: "Android App Development",
    icon: require("../assets/images/icons/android-development.png"),
    description:
      "Specializing in both Java and Kotlin, we build custom Android apps that align with your unique vision and business goals, delivering robust and efficient solutions.",
  },
  {
    id: 3,
    title: "Flutter App Development",
    icon: require("../assets/images/icons/flutter-development.png"),
    description:
      "With Flutter, we build cross-platform apps for both iOS and Android using a single codebase. Despite challenges with its default web architecture, we apply smart strategies for seamless functionality.",
  },
  {
    id: 4,
    title: "Hybrid App Development",
    icon: require("../assets/images/icons/hybrid-app-development.png"),
    description:
      "Our hybrid app development services provide mobile-friendly, feature-rich apps that work flawlessly across both iOS and Android devices, tailored to your business requirements.",
  },
];

// development workflow
export const webDevelopmentWorkflow = [
  {
    id: "01",
    title: "Requirements Analysis",
    icon: require("../assets/images/icons/requirement-analysis.png"),
    description:
      "We delve deep to understand your goals, target audience, and project needs. Through collaborative discussions, we solidify the website's functionalities and user journeys.",
  },
  {
    id: "02",
    title: "Design & Planning",
    icon: require("../assets/images/icons/planning.png"),
    description:
      "Our team crafts a user-centric blueprint. We meticulously plan the website's architecture, information flow, and visual identity, ensuring an intuitive and engaging experience.",
  },
  {
    id: "03",
    title: "Development",
    icon: require("../assets/images/icons/software-development.png"),
    description:
      "Our skilled developers bring your vision to life. We leverage cutting-edge technologies to build a secure and scalable website or web application that seamlessly integrates with your existing systems.",
  },
  {
    id: "04",
    title: "Testing",
    icon: require("../assets/images/icons/testing.png"),
    description:
      "We subject your website to rigorous testing to ensure flawless performance across all devices. Once satisfied, we launch your masterpiece with a smooth transition and ongoing support.",
  },
  {
    id: "05",
    title: "Support",
    icon: require("../assets/images/icons/support.png"),
    description:
      "Our commitment extends beyond launch. We provide ongoing maintenance, security updates, and expert assistance to keep your website thriving in the ever-evolving digital landscape.",
  },
];

export const appDevelopmentWorkflow = [
  {
    id: "01",
    title: "Requirements Analysis",
    icon: require("../assets/images/icons/requirement-analysis.png"),
    description:
      "We delve deep to understand your app's purpose, target audience, and desired functionalities. Through workshops and discussions, we'll solidify your app's foundation.",
  },
  {
    id: "02",
    title: "Design & Planning",
    icon: require("../assets/images/icons/planning.png"),
    description:
      "We craft a user-centric experience. Our designers create intuitive interfaces, while our planners map out the development roadmap, ensuring a smooth and efficient build.",
  },
  {
    id: "03",
    title: "Development",
    icon: require("../assets/images/icons/software-development.png"),
    description:
      "Our skilled engineers bring your app to life. Using cutting-edge tools and following best practices, we meticulously code every feature, ensuring a robust and functional app.",
  },
  {
    id: "04",
    title: "Testing",
    icon: require("../assets/images/icons/testing.png"),
    description:
      "We rigorously test every aspect of your app across different devices and scenarios. Our goal To identify and fix any glitches before launch, guaranteeing a seamless user experience.",
  },
  {
    id: "05",
    title: "Support",
    icon: require("../assets/images/icons/support.png"),
    description:
      "Your app's success is our priority. We offer ongoing support to address any issues and provide updates to keep your app functioning at its best.",
  },
];

// General Development Workflow
export const generalDevelopmentWorkflow = [
  {
    id: "01",
    title: "Requirements Gathering",
    icon: require("../assets/images/icons/requirement-analysis.png"),
    description:
      "We collaborate with stakeholders to thoroughly understand their needs and objectives, ensuring all project requirements are accurately captured and aligned with business goals.",
  },
  {
    id: "02",
    title: "Design & Planning",
    icon: require("../assets/images/icons/planning.png"),
    description:
      "Our team develops intuitive, user-friendly designs and creates a strategic roadmap, including detailed timelines, milestones, and resources needed to achieve successful project delivery.",
  },
  {
    id: "03",
    title: "Development",
    icon: require("../assets/images/icons/software-development.png"),
    description:
      "Our expert developers transform the design into a fully functioning solution, using the latest technologies to build a reliable, scalable, and secure product that meets all functional and technical specifications.",
  },
  {
    id: "04",
    title: "Testing",
    icon: require("../assets/images/icons/testing.png"),
    description:
      "We conduct comprehensive testing, covering performance, security, and usability, ensuring the product is robust, bug-free, and delivers an optimal experience across all platforms.",
  },
  {
    id: "05",
    title: "Support",
    icon: require("../assets/images/icons/support.png"),
    description:
      "We provide continuous support and maintenance, ensuring the product remains up-to-date and performs seamlessly, while addressing any issues or enhancements as your business evolves.",
  },
];

// testimonials
export const testimonials = [
  {
    id: 1,
    name: "John Peterson",
    img: require("../assets/images/testimonials/review-p1.png"),
    designation: "CEO of TechNext Solutions",
    review:
      "Working with Eskaliotech was a game-changer for our business. They designed a mobile app that transformed the way we interact with our customers. Since launching the app, our user engagement has increased by 45%, and we've seen a 30% boost in revenue, adding $1.2M to our bottom line in just six months! Their expertise and attention to detail are unmatched.",
  },
  {
    id: 2,
    name: "Samantha Green",
    img: require("../assets/images/testimonials/review-p2.png"),
    designation: "CTO of FinServ Global",
    review:
      "Our gaming studio needed a partner that could bring our vision to life, and Eskaliotech delivered beyond expectations. Their team crafted a visually stunning and engaging game that quickly became a hit in the market. Within three months of launch, we saw $800K in revenue and over 100,000 downloads. Their creativity and technical skills are second to none.",
  },
  {
    id: 3,
    name: "Mark Davis",
    img: require("../assets/images/testimonials/review-p3.png"),
    designation: "COO of E-Commerce Hub",
    review:
      "Eskaliotech helped us migrate our entire infrastructure to the cloud with zero downtime. Not only did we improve our operational efficiency, but we also reduced our IT expenses by 35%, saving over $250,000 annually. Their support and expertise have made scaling our business a breeze. We couldn’t have done it without them.",
  },
  {
    id: 4,
    name: "Lisa Wong",
    img: require("../assets/images/testimonials/review-p4.png"),
    designation: "IT Director at Global Enterprises",
    review:
      "We partnered with Eskaliotech to develop an AI-powered recommendation engine for our e-commerce platform. The results have been phenomenal! Our conversion rates increased by 28%, and we’ve generated an additional $500K in monthly revenue. Their team’s ability to understand our needs and deliver results exceeded our expectations.",
  },
  {
    id: 5,
    name: "David Thompson",
    img: require("../assets/images/testimonials/review-p5.png"),
    designation: "HR Director at HealthCare Innovators",
    review:
      "Eskaliotech automated several key processes in our operations, cutting our manual workload by 60%. This efficiency has allowed us to save over $300,000 annually in operational costs. Their RPA solutions have not only streamlined our workflow but also improved accuracy across the board. We highly recommend their services!",
  },
];

// industry company serve
export const industriesCompanyServe = [
  {
    id: 1,
    title: "Healthcare",
    img: require("../assets/images/industries/Healthcare.webp"),
    desc: "Enhancing patient care and improving healthcare operations through AI-driven diagnostics, remote monitoring, and advanced data analytics.",
  },
  {
    id: 2,
    title: "E-commerce & Retail",
    img: require("../assets/images/industries/E-commerce & Retail.webp"),
    desc: "Empowering e-commerce businesses with personalized shopping experiences, efficient inventory management, and secure payment processing.",
  },
  {
    id: 3,
    title: "Finance & Banking",
    img: require("../assets/images/industries/Finance & Banking.webp"),
    desc: "Revolutionizing financial services with AI, blockchain, and machine learning for secure transactions, risk analysis, and enhanced investment strategies.",
  },
  {
    id: 4,
    title: "Energy",
    img: require("../assets/images/industries/Energy.webp"),
    desc: "Leveraging AI, IoT, and data analytics to optimize energy usage, improve sustainability, and enable accurate forecasting in the energy sector.",
  },
  {
    id: 5,
    title: "Real Estate",
    img: require("../assets/images/industries/Real Estate.webp"),
    desc: "Transforming property management and real estate investments by utilizing AI, predictive analytics, and data-driven insights for better decision-making.",
  },
  {
    id: 6,
    title: "Manufacturing",
    img: require("../assets/images/industries/Manufacturing.webp"),
    desc: "Optimizing manufacturing processes with AI, machine learning, and IoT to automate operations, predict maintenance needs, and enhance productivity.",
  },
  {
    id: 7,
    title: "Data Analytics & Business Intelligence",
    img: require("../assets/images/industries/Data Analytics & Business Intelligence.webp"),
    desc: "Unlocking actionable insights from big data to drive strategic decision-making and accelerate business growth through advanced analytics.",
  },
  {
    id: 8,
    title: "IoT Development",
    img: require("../assets/images/industries/IoT Development.webp"),
    desc: "Connecting devices, sensors, and systems to drive automation, improve efficiency, and enable real-time monitoring for better decision-making.",
  },
  {
    id: 9,
    title: "Logistics & Supply Chain",
    img: require("../assets/images/industries/Logistics & Supply Chain.webp"),
    desc: "Enhancing logistics operations and supply chain management with AI, IoT, and real-time tracking to optimize routes, inventory, and overall efficiency.",
  },
  {
    id: 10,
    title: "Education",
    img: require("../assets/images/industries/Education.webp"),
    desc: "Improving learning outcomes through personalized education, predictive analytics, and automation of administrative tasks using AI and machine learning.",
  },
  {
    id: 11,
    title: "Telecom",
    img: require("../assets/images/industries/Telecom.webp"),
    desc: "Enhancing telecom operations with AI-powered solutions for network optimization, customer experience management, and fraud prevention.",
  },
];

// portfolio images (web development)
export const webPortfolio = [
  {
    id: 1,
    img: require("../assets/images/web_projects/1.webp"),
    title: "FE-Finance",
  },
  {
    id: 2,
    img: require("../assets/images/web_projects/2.webp"),
    title: "Ocxee",
  },
  {
    id: 3,
    img: require("../assets/images/web_projects/3.webp"),
    title: "Leaderbridge",
  },
  {
    id: 4,
    img: require("../assets/images/web_projects/4.webp"),
    title: "Gigzio",
  },
  {
    id: 5,
    img: require("../assets/images/web_projects/5.webp"),
    title: "FE Group",
  },
  {
    id: 6,
    img: require("../assets/images/web_projects/6.webp"),
    title: "V Talkz",
  },
];

// portfolio images (app development)
export const appPortfolio = [
  {
    id: 1,
    img: require("../assets/images/app_projects/1.webp"),
    title: "PartEx",
  },
  {
    id: 2,
    img: require("../assets/images/app_projects/2.webp"),
    title: "Find A Driver",
  },
  {
    id: 3,
    img: require("../assets/images/app_projects/3.webp"),
    title: "Artisan Express",
  },
  {
    id: 4,
    img: require("../assets/images/app_projects/4.webp"),
    title: "House of Deliverance",
  },
];

// services details contents
export const servicesList = [
  {
    title: "Web Development",
    img1: require("../assets/images/services-details/web-development1.jpeg"),
    img2: require("../assets/images/services-details/web-development2.jpg"),
    icon: require("../assets/images/icons/software-development.png"),
    shortDescription:
      "Building websites using code, design, and content for user-friendly online experiences.",
    intro: {
      description:
        "At Eskaliotech Solutions, we believe that web development goes beyond just creating websites. It's about crafting dynamic, interactive experiences that drive business success and engage users. As leaders in tech innovation, we use the latest advancements in web development to deliver exceptional results that help businesses thrive in today's digital world.",
    },
    approach: {
      title: "Our Approach to Web Development",
      description:
        "We offer a comprehensive web development solution that covers both front-end and back-end needs. Our front-end developers specialize in creating visually appealing, intuitive, and responsive user interfaces using HTML, CSS, and JavaScript. These interfaces are designed to provide seamless experiences across various devices, crucial for making lasting impressions in a fast-paced digital market. On the back-end, we ensure that our web applications are secure, efficient, and scalable. Our expert developers work with technologies like PHP, Ruby, and Python to build systems that handle data transactions safely and effectively, setting a solid foundation for future growth without sacrificing performance or security.",
    },
    services: [
      {
        title: "E-Commerce Platform Development",
        description:
          "Whether it's a simple online store or a complex e-commerce platform, we create solutions that optimize sales, improve customer experience, and streamline transactions.",
      },
      {
        title: "Custom Web Application Development",
        description:
          "We build tailor-made web applications to meet the unique demands of your business, ensuring a seamless user experience, high performance, and top-notch security.",
      },
      {
        title: "Full Stack Development",
        description:
          "Our full-stack development services cover both client-side and server-side development, ensuring quick, reliable, and scalable web solutions.",
      },
    ],
    conclusion: {
      description:
        "At Eskaliotech Solutions, we see a future where technology breaks barriers and opens new avenues for businesses. Our commitment to innovation drives us to explore emerging technologies and methodologies that shape the future of web solutions. With a dedicated team focused on excellence, we strive to deliver customized web development services that not only meet but exceed our clients' expectations, setting them up for long-term success in the digital world.",
    },
  },
  {
    title: "App Development",
    img1: require("../assets/images/services-details/app-development1.jpeg"),
    img2: require("../assets/images/services-details/app-development2.jpg"),
    icon: require("../assets/images/icons/android-development.png"),
    shortDescription:
      "Creating mobile applications using code, design, and user-centered features.",
    intro: {
      description:
        "At Eskaliotech Solutions, we design and develop mobile applications that are intuitive, fast, and secure. We specialize in delivering high-performance applications for iOS and Android, ensuring that your business reaches its audience with a seamless user experience.",
    },
    approach: {
      title: "Our Approach to App Development",
      description:
        "Our app development process involves creating tailored solutions for both mobile platforms, with a focus on user-friendly interfaces, robust functionality, and flawless performance. Whether it's building native apps or cross-platform solutions, our team ensures that the app meets the specific needs of your business and users.",
    },
    services: [
      {
        title: "iOS App Development",
        description:
          "Our iOS app development services ensure that your app is fully optimized for Apple's ecosystem, delivering top-notch performance and design.",
      },
      {
        title: "Android App Development",
        description:
          "We develop intuitive and scalable Android apps that provide seamless functionality and exceptional user experiences across devices.",
      },
      {
        title: "Cross-Platform App Development",
        description:
          "We build cross-platform applications that run smoothly on both iOS and Android, maximizing your app's reach and minimizing development time and cost.",
      },
    ],
    conclusion: {
      description:
        "With our expert team and industry-leading tools, Eskaliotech Solutions ensures that your mobile app not only meets but exceeds expectations. We focus on delivering applications that are scalable, secure, and ready for the ever-evolving digital world.",
    },
  },
  {
    title: "Game Development",
    img1: require("../assets/images/services-details/game-development1.webp"),
    img2: require("../assets/images/services-details/game-development2.webp"),
    icon: require("../assets/images/icons/game-development.png"),
    shortDescription:
      "Creating engaging and immersive gaming experiences across multiple platforms.",
    intro: {
      description:
        "At Eskaliotech Solutions, we combine creativity with technical expertise to develop engaging games that captivate players. Our game development services cover everything from concept to deployment, ensuring high-quality gaming experiences across various platforms.",
    },
    approach: {
      title: "Our Approach to Game Development",
      description:
        "We follow a comprehensive game development approach that emphasizes both creativity and technical excellence. From story development and character design to programming and testing, our team ensures that each game delivers an engaging and memorable experience for players.",
    },
    services: [
      {
        title: "Mobile Game Development",
        description:
          "We create engaging mobile games optimized for both iOS and Android platforms, focusing on smooth gameplay and intuitive controls.",
      },
      {
        title: "PC and Console Game Development",
        description:
          "Our team develops high-quality games for PC and gaming consoles, incorporating advanced graphics and engaging gameplay mechanics.",
      },
      {
        title: "Game Design and Strategy",
        description:
          "We provide comprehensive game design services, including storyline development, character design, and gameplay mechanics optimization.",
      },
    ],
    conclusion: {
      description:
        "Eskaliotech Solutions is committed to creating innovative and entertaining games that push the boundaries of what's possible in interactive entertainment, delivering memorable experiences that keep players coming back for more.",
    },
  },
  {
    title: "Cloud Computing Services",
    img1: require("../assets/images/services-details/cloudcomputing1.jpg"),
    img2: require("../assets/images/services-details/cloudcomputing2.png"),
    icon: require("../assets/images/icons/cloudcomputing.png"),
    shortDescription:
      "Providing scalable cloud solutions for businesses of all sizes.",
    intro: {
      description:
        "We offer comprehensive cloud computing services that help businesses leverage the power of cloud technology for improved efficiency, scalability, and cost-effectiveness. Our solutions enable seamless integration of cloud services into existing infrastructure.",
    },
    approach: {
      title: "Our Approach to Cloud Computing",
      description:
        "We take a strategic approach to cloud computing, focusing on your business needs and objectives. Our team designs and implements cloud solutions that optimize performance, enhance security, and ensure reliability while maintaining cost efficiency.",
    },
    services: [
      {
        title: "Cloud Migration Services",
        description:
          "We help businesses smoothly transition their existing infrastructure and applications to the cloud, ensuring minimal disruption to operations.",
      },
      {
        title: "Cloud Infrastructure Management",
        description:
          "Our team provides comprehensive management of cloud infrastructure, including monitoring, maintenance, and optimization of cloud resources.",
      },
      {
        title: "Cloud Integration Solutions",
        description:
          "We develop and implement solutions that integrate various cloud services and applications, creating a cohesive and efficient cloud ecosystem.",
      },
    ],
    conclusion: {
      description:
        "Eskaliotech Solutions empowers businesses with robust cloud computing solutions that drive digital transformation, enhance operational efficiency, and provide the foundation for future growth.",
    },
  },
  {
    title: "AI & ML Development",
    img1: require("../assets/images/services-details/ai1.jpg"),
    img2: require("../assets/images/services-details/ai2.jpg"),
    icon: require("../assets/images/icons/ai.png"),
    shortDescription:
      "Developing intelligent systems using AI and ML technologies.",
    intro: {
      description:
        "We specialize in developing cutting-edge AI and ML solutions that help businesses automate processes, gain insights, and make data-driven decisions. Our expertise spans across various AI and ML technologies, enabling businesses to stay ahead in the digital age.",
    },
    approach: {
      title: "Our Approach to AI & ML Development",
      description:
        "We take a systematic approach to AI and ML development, starting with understanding your business needs and data assets. Our team develops custom solutions using state-of-the-art algorithms and frameworks, ensuring optimal performance and scalability.",
    },
    services: [
      {
        title: "Custom AI Solutions",
        description:
          "We develop tailored AI solutions that address specific business challenges and opportunities, from automated decision-making to intelligent process automation.",
      },
      {
        title: "Machine Learning Models",
        description:
          "Our team creates and deploys sophisticated machine learning models that learn from your data to make accurate predictions and recommendations.",
      },
      {
        title: "AI Integration Services",
        description:
          "We help businesses integrate AI capabilities into their existing systems and workflows, maximizing the value of their technology investments.",
      },
    ],
    conclusion: {
      description:
        "Eskaliotech Solutions drives innovation through AI and ML development, helping businesses harness the power of intelligent technologies to achieve their strategic objectives.",
    },
  },
  {
    title: "Robotic Process Automation",
    img1: require("../assets/images/services-details/rpa1.jpeg"),
    img2: require("../assets/images/services-details/rpa2.jpeg"),
    icon: require("../assets/images/icons/rpa.png"),
    shortDescription:
      "Automating repetitive tasks and processes using RPA technology.",
    intro: {
      description:
        "Our RPA services help businesses automate routine tasks and workflows, improving efficiency and reducing errors. We implement intelligent automation solutions that free up valuable human resources for more strategic activities.",
    },
    approach: {
      title: "Our Approach to RPA",
      description:
        "We take a comprehensive approach to RPA implementation, starting with process analysis and optimization. Our team designs and deploys automated solutions that seamlessly integrate with existing systems and workflows.",
    },
    services: [
      {
        title: "Process Analysis and Design",
        description:
          "We analyze your business processes to identify automation opportunities and design optimal RPA solutions.",
      },
      {
        title: "RPA Implementation",
        description:
          "Our team implements and configures RPA solutions using leading platforms and technologies, ensuring smooth integration with existing systems.",
      },
      {
        title: "RPA Maintenance and Support",
        description:
          "We provide ongoing maintenance and support for RPA solutions, ensuring continued performance and addressing any issues that arise.",
      },
    ],
    conclusion: {
      description:
        "Eskaliotech Solutions delivers RPA solutions that drive operational efficiency, reduce costs, and improve accuracy across business processes.",
    },
  },
  {
    title: "AR & VR Development",
    img1: require("../assets/images/services-details/arvr1.jpg"),
    img2: require("../assets/images/services-details/arvr2.jpeg"),
    icon: require("../assets/images/icons/arvr.png"),
    shortDescription:
      "Creating immersive AR and VR experiences for various applications.",
    intro: {
      description:
        "We specialize in developing cutting-edge AR and VR solutions that transform how businesses engage with their customers and operate. Our immersive experiences push the boundaries of what's possible in digital interaction.",
    },
    approach: {
      title: "Our Approach to AR & VR Development",
      description:
        "We take a user-centered approach to AR and VR development, focusing on creating immersive experiences that are both engaging and practical. Our team uses the latest technologies and best practices to deliver solutions that meet your specific needs.",
    },
    services: [
      {
        title: "AR Application Development",
        description:
          "We create augmented reality applications that enhance real-world environments with digital content and interactive features.",
      },
      {
        title: "VR Experience Design",
        description:
          "Our team develops virtual reality experiences that transport users to fully immersive digital environments for training, entertainment, or business applications.",
      },
      {
        title: "Mixed Reality Solutions",
        description:
          "We build mixed reality solutions that combine elements of both AR and VR to create unique and powerful interactive experiences.",
      },
    ],
    conclusion: {
      description:
        "Eskaliotech Solutions leads the way in AR and VR development, creating immersive experiences that drive engagement and deliver value across various industries.",
    },
  },
  {
    title: "IT Consulting and Strategy",
    img1: require("../assets/images/services-details/it-consulting1.webp"),
    img2: require("../assets/images/services-details/it-consulting2.webp"),
    icon: require("../assets/images/icons/consulting.png"),
    shortDescription:
      "Providing strategic IT guidance and solutions for business growth.",
    intro: {
      description:
        "Our IT consulting services help businesses align their technology investments with their strategic objectives. We provide expert guidance on digital transformation, technology selection, and implementation strategies.",
    },
    approach: {
      title: "Our Approach to IT Consulting",
      description:
        "We take a holistic approach to IT consulting, considering your business goals, current technology landscape, and future needs. Our team provides actionable recommendations and implementation support to drive successful outcomes.",
    },
    services: [
      {
        title: "Digital Transformation Strategy",
        description:
          "We help businesses develop and implement comprehensive digital transformation strategies that drive innovation and growth.",
      },
      {
        title: "Technology Assessment",
        description:
          "Our team conducts thorough assessments of your current technology infrastructure and provides recommendations for optimization and improvement.",
      },
      {
        title: "Implementation Planning",
        description:
          "We create detailed implementation plans for new technology initiatives, ensuring smooth execution and minimal disruption to operations.",
      },
    ],
    conclusion: {
      description:
        "Eskaliotech Solutions provides expert IT consulting services that help businesses navigate the complex technology landscape and make informed decisions that drive success.",
    },
  },
];
